mutation OverwriteEditablesWithEditableGroupAndMasterTemplateScope(
    $overwrites: [InputOverwriteEditableWithEditableGroupAndMasterTemplateScope]!
    $campaignId: ID!
) {
    overwriteEditablesWithEditableGroupAndMasterTemplateScope(campaignId: $campaignId, overwrites: $overwrites) {
        _id
    }
}
